/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents payment status dictionary
 */
export enum FalconDocumentsPaymentStatus {
  All = 0,
  Settled,
  Unsettled,
  UnsettledExpired
}
